<template>
  <div>
    <div class="app-content--inner p-0 d-flex flex-column">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <h3 class="text-uppercase" style="color:#6190bf">
              tambah data pic faskes
            </h3>
            <br />

            <b-form @submit.prevent="submitInputKlinik">
              <b-row class="d-flex align-items-center">
                <b-col
                  sm="12"
                  v-for="(inputKlinik, index) in tmpInputKlinikData"
                  :key="inputKlinik.id"
                >
                  <div class="card card-box mb-3">
                    <div class="card-body">
                      <b-row class="d-flex align-items-center mb-2">
                        <b-col lg="3" sm="3">
                          <label class="font-weight-bold">Nama PIC</label>
                          <label style="color:red"> *</label>
                        </b-col>
                        <b-col sm="4">
                          <label class="font-weight-bold">Alamat Email</label>
                          <label style="color:red"> *</label>
                        </b-col>
                        <b-col lg="3" sm="3">                          
                          <label class="font-weight-bold">No. Handphone</label>
                          <label style="color:red"> *</label>
                        </b-col>
                      </b-row>
                      <b-row class="d-flex align-items-center mb-3">
                        <b-col lg="3" sm="3">
                          <div role="group">
                            <b-form-input
                              :value="inputKlinik.nama"
                              @change="
                                onChangeValue({
                                  label: 'nama',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputNamaKlinik(
                                  $event,
                                  index,
                                  inputKlinik,
                                  'nama'
                                )
                              "
                              :state="
                                errorState({ label: 'nama', index })
                              "
                              maxlength="50"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputKlinik.error &&
                                  inputKlinik.error.nama.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col sm="4">
                          <div role="group">
                            <b-form-input
                              type="email"
                              :value="inputKlinik.email"
                              @change="
                                onChangeValue({
                                  label: 'email',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputEmail(
                                  $event,
                                  index,
                                  inputKlinik,
                                  'email'
                                )
                              "
                              :state="
                                errorState({ label: 'email', index })
                              "
                              maxlength="50"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputKlinik.error &&
                                  inputKlinik.error.email.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col sm="3">
                          <div role="group">
                            <b-form-input
                              :value="inputKlinik.nomor_telp"
                              @change="
                                onChangeValue({
                                  label: 'nomor_telp',
                                  index,
                                  $event
                                })
                              "
                              @input="
                                onInputNomorTelp(
                                  $event,
                                  index,
                                  inputKlinik,
                                  'nomor_telp'
                                )
                              "
                              :state="
                                errorState({ label: 'nomor_telp', index })
                              "
                              maxlength="15"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputKlinik.error &&
                                inputKlinik.error.nomor_telp.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="d-flex align-items-center mb-2">
                        <b-col lg="4" sm="4">
                          <label class="font-weight-bold">Nama Klinik</label>
                          <label style="color:red"> *</label>
                        </b-col>
                        <b-col sm="4">
                          <label class="font-weight-bold">Kabupaten/Kota</label>
                        </b-col>
                      </b-row>
                      <b-row class="d-flex align-items-center mb-3">
                        <b-col lg="4" sm="4">
                          <div role="group">
                            <vue-select
                              style="font-size:13px"
                              :options="kliniks"
                              v-model="tmpInputKlinikData[index].nama_klinik"
                              placeholder="Pilih Klinik"
                              @input="
                                onDataKlinik(
                                  tmpInputKlinikData[index].nama_klinik,
                                  index,
                                  inputKlinik,
                                  'nama_klinik'
                                )
                              "
                              @change="
                                onChangeValue({
                                  label: 'nama_klinik',
                                  index,
                                  $event
                                })
                              "
                            />

                            <b-form-invalid-feedback>
                              {{
                                inputKlinik.error &&
                                inputKlinik.error.nama_klinik.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col sm="4">
                          <div role="group">
                            <b-form-input
                              disabled
                              :value="tmpInputKlinikData[index].kota"
                              v-model="tmpInputKlinikData[index].kota"
                              @change="
                                onChangeValue({
                                  label: 'kota',
                                  index,
                                  $event
                                })
                              "
                              :state="
                                errorState({ label: 'kota', index })
                              "
                              maxlength="50"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                              {{
                                inputKlinik.error &&
                                inputKlinik.error.kota.desc
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-col>
                        <b-col sm="4" style="height: 65px">
                          <b-button
                            v-if="index > 0"
                            variant="danger"
                            class="float-right"
                            :style="btnRemoveMobileStyle"
                            @click="removeInputklinikData(index)"
                          >
                            <font-awesome-icon icon="minus" />
                          </b-button>

                          <b-button
                            variant="first"
                            style="padding: .5rem .8rem; border-radius: 100%; background-color:#1bbf2c;border-color:transparent"
                            class="mr-3 float-right"
                            @click="addInputklinikData"
                          >
                            <font-awesome-icon icon="plus" />
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row class="d-flex align-items-center">
                <b-col lg="8" md="7" sm="6"> </b-col>
                <b-col lg="4" md="5" sm="6" align="right">
                  <b-button
                    class="text-capitalize mr-2"
                    variant="danger"
                    :to="{ name: 'pic-klinik-list' }"
                    >tutup</b-button
                  >
                  <b-button
                   
                    type="submit"
                    variant="primary"
                    >selesai</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

import {mapGetters} from "vuex";
library.add(faPlus, faMinus);

export default {
  components: {
    "vue-select": () => import("@/components/VueSelect.vue")
  },
  data: () => ({
    cities: [],
    selectedKota: null,
    selectedKlinik: null,
    kliniks: [],
    tmpInputKlinikData: [
      {
        nama: null,
        email: null,
        nomor_telp:null,
        nama_klinik: null,
        klinik: null,
        klinik_id: null,
        kota: null
      }
    ],
    kodeContainer: [],
    namaContainer: [],
    beingSubmit: false,
    namaLayananContainer: [],
    tlpLayananContainer: [],
    emailLayananContainer: [],
    klinikLayananContainer: [],
    tlpLayananExistsInDb: [],
    emailLayananExistsInDb: []
  }),
  computed: {
    ...mapGetters(["getKlinikId"]),
    btnRemoveMobileStyle() {
      if (this.isMobile()) {
        return {
          padding: ".4rem .7rem",
          "border-radius": "100%",
          "margin-left": "-22px"
        };
      }

      return {
        padding: ".5rem .8rem",
        "border-radius": "100%",
        "margin-left": "-8px"
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        text: `Anda yakin untuk keluar dari halaman ini?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  mounted() {
    this.getKlinik();
    this.getKota();
    this.tmpInputKlinikData = this.settmpInputKlinikData();
  },
  methods: {
    async getKlinik() {
      try {
        const res = await this.$axios.get(
          `klinik/dropdown?klinik_id=${this.getKlinikId}`
        );
        const { data } = res.data;
        this.kliniks = data.map(item => {
          return {
            id: item.id,
            label: item.nama_klinik
          };
        });
      } catch (error) {}

    },
    async getKota(val, index) {
      try {
        const res = await this.$axios.get(
          `klinik/pic-exists/${val.id}`
        );
        const { status, data } = res.data;
        if(status) {
          this.tmpInputKlinikData[index].error.kota.error = true;
          this.tmpInputKlinikData[index].error.kota.desc = "";
          this.tmpInputKlinikData[index].kota = data.kota_detail.nama
          this.tmpInputKlinikData[index].klinik_id = data.id
        } else {
          this.tmpInputKlinikData[index].error.nama_klinik.error = false;
          this.tmpInputKlinikData[index].error.nama_klinik.desc = "Klinik telah ditambahkan sebelumnya";
          this.tmpInputKlinikData[index].kota = null
          this.tmpInputKlinikData[index].klinik_id = null
        }
      } catch (error) {}
    },
    onDataKlinik(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      Vue.set(o, p, val.label);
      Vue.set(o, 'klinik', val)
      Vue.set(this.klinikLayananContainer, index, val);

      let isDuplicate = false;
      this.klinikLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.klinikLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item.label == item2.label) {
              this.tmpInputKlinikData[i].error["kota"].error = null;
              this.tmpInputKlinikData[i].kota = null
              this.tmpInputKlinikData[i].error["nama_klinik"].error = false;
              this.tmpInputKlinikData[i].error["nama_klinik"].desc = "Klinik tidak boleh sama";
              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputKlinikData[i].error["nama_klinik"].error = true;
          this.tmpInputKlinikData[i].error["nama_klinik"].desc = "";
          this.getKota(item, i);
        }
      });
    },
    settmpInputKlinikData() {
      return this.tmpInputKlinikData.map(item => {
        const tmp = Object.keys(item).reduce((obj, key) => {
          if (key !== "error") {
            obj[key] = this.generateErrorObj();
          }
          return obj;
        }, {});
        return {
          ...item,
          error: tmp
        };
      });
    },
    generateErrorObj() {
      return {
        error: null,
        desc: null
      };
    },
    errorState({ label, index }) {
      const { tmpInputKlinikData } = this;
      if (
        tmpInputKlinikData[index].error &&
        tmpInputKlinikData[index].error[label]
      ) {
        return tmpInputKlinikData[index].error[label].error;
      } else {
        return null;
      }
    },
    errorDesc({ label, index }) {
      const { tmpInputKlinikData } = this;
      if (
        tmpInputKlinikData[index].error &&
        tmpInputKlinikData[index].error[label]
      ) {
        return tmpInputKlinikData[index].error[label].desc;
      }
    },
    onKeyupTarif($event, index) {
      const { tmpInputKlinikData } = this;

      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    placeholderInput(label = "") {
      return startCase(`input ${label}`);
    },
    validateInput({ label, $event }) {
      return {
        error: ($event && true) || false,
        desc: (!$event && "kolom harus diisi") || ""
      };
    },
    validateAll() {
      const valItems = ["nama", "email","nomor_telp", "nama_klinik", "kota"];
      this.tmpInputKlinikData.forEach(item => {
        valItems.forEach(valItem => {
          if (item.error[valItem].error == false) return;

          let label
          if(valItem == "nomor_telp") label = "no_handphone"
          else if(valItem == "nama_klinik") label = "klinik"
          else label = valItem

          if (!item[valItem]) {
            item.error[valItem].error = false;
            item.error[valItem].desc = startCase(label.replace("_", " ")) + " harus diisi";
          } else {
            item.error[valItem].error = true;
            item.error[valItem].desc = "";
          }
        });
      });
    },
    submitInputKlinik() {
      const { tmpInputKlinikData, validateAll } = this;
      this.$nextTick(() => {
        validateAll();

        let isError = false;
        let isErrorRequired = false;
        let isErrorDuplicate = false;
        let isErrorExists = false;

        tmpInputKlinikData.forEach(klinikData => {
          for (let errIndex in klinikData.error) {
            if (klinikData.error[errIndex].error == false) {
              isError = true;

              if (/(harus diisi)/i.test(klinikData.error[errIndex].desc)) {
                isErrorRequired = true;
              } else if (
                /(telah ditambahkan)/i.test(klinikData.error[errIndex].desc)
              ) {
                isErrorDuplicate = true;
              } else if (/(sudah ada)/i.test(klinikData.error[errIndex].desc)) {
                isErrorExists = true;
              }
            }
          }
        });

        if (isError == false) {
          this.$swal({
            text: `Anda yakin untuk menyelesaikan penambahan data PIC?`,
            type: "warning",
            showCancelButton: true,
            cancelButtonText: startCase("tidak"),
            confirmButtonText: startCase("ya")
          }).then(res => {
            if (res.value) {
              this.doSubmitInputKlinik();
            }
          });
        } else {
          let errorMessage = {
            required: "Silakan cek kembali pengisian data Anda!"
          };
          let jenisError = "";
          if (isErrorRequired) jenisError = "required";
          else if (isErrorDuplicate) jenisError = "duplicate";
          else if (isErrorExists) jenisError = "exists";

          this.$swal({
            type: "warning",
            text: errorMessage[jenisError]
          });
        }
      });
    },
    async doSubmitInputKlinik() {
      const { constructPostData } = this;
      try {
        const res = await this.$axios.post(
          `klinik/pic`, constructPostData()
        );
        const { status, data } = res.data;
        if(status) {
          this.beingSubmit = true;
          this.$swal({
            text: "PIC berhasil ditambahkan. Email aktivasi telah dikirimkan kepada PIC yang ditambahkan.",
            type: "success",
            confirmButtonText: startCase("OK")
          });
            this.$router.push({ path: "/pic-klinik" });
        } else {
          this.$swal({
            text: "PIC gagal ditambahkan.",
            type: "warning",
            confirmButtonText: startCase("OK")
          });
        }
      } catch (errror) {
        const x = errror.response.data;
        const y = Object.keys(x);
        y.map(item => {
          const z = item.split(".");
          this.tmpInputKlinikData[z[1]].error.nama.desc =
            x[item][x[item].length - x[item].length];
        });
        var d = errror.response.data.length;
      }
    },
    constructPostData() {
      const { tmpInputKlinikData } = this;
      const tmp = tmpInputKlinikData.map(item => {
        const x = Object.keys(item).filter(y => !["error"].includes(y));
        const z = x.reduce((obj, key) => {
          let q = key;
          if(q != 'kota' && q != 'nama_klinik' && q != 'klinik') {
            obj[q] = item[key];
          }
          return obj;
        }, {});
        z.klinik_id = this.getKlinikId;
        z.klinik_id_pic = item.klinik.id
        return z;
      });
      return tmp;
    },
    onChangeValue({ index, label, $event }) {
      const { tmpInputKlinikData, validateInput } = this;
      const tmp = tmpInputKlinikData[index];
      if (tmp.error[label].error !== false) {
        tmp.error[label] = validateInput({
          label,
          $event
        });
      }

      if (label !== "email") {
        tmp[label] = $event;
        Vue.set(this.tmpInputKlinikData, index, tmp);
      }
    },
    onInputNamaKlinik(valRaw, index, o, p) {
      if (this._timeoutNamaKlinik) clearTimeout(this._timeoutNamaKlinik);
      let val = valRaw.toLowerCase().trim();
      Vue.set(o, p, valRaw);
      Vue.set(this.namaLayananContainer, index, val);

      if (!val) {
        this.tmpInputKlinikData[index].error["nama"].error = false;
        this.tmpInputKlinikData[index].error["nama"].desc =
          "Nama harus diisi";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];

      this.namaLayananContainer.forEach((item, i) => {
        if (isDuplicate == false) {
          this.tmpInputKlinikData[i].error["nama"].error = true;
          this.tmpInputKlinikData[i].error["nama"].desc = "";

          needDbChecks.push(i);
        }
      });
    },
    onInputNomorTelp(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      Vue.set(o, p, val);
      Vue.set(this.tlpLayananContainer, index, val);

      if (val.match(/[^0-9/]+/) !== null) {
        this.tmpInputKlinikData[index].error["nomor_telp"].error = false;
        this.tmpInputKlinikData[index].error["nomor_telp"].desc =
          "Hanya bisa menulis angka";
        return;
      }

      if (val.length == 0) {
        this.tmpInputKlinikData[index].error["nomor_telp"].error = false;
        this.tmpInputKlinikData[index].error["nomor_telp"].desc =
          "Kolom harus diisi";
        return;
      } else if (val.length < 10) {
        this.tmpInputKlinikData[index].error["nomor_telp"].error = false;
        this.tmpInputKlinikData[index].error["nomor_telp"].desc =
          "No. Handphone minimal 10 karakter";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];
      this.tlpLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.tlpLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item == item2) {
              this.tmpInputKlinikData[i].error["nomor_telp"].error = false;
              this.tmpInputKlinikData[i].error["nomor_telp"].desc =
                "No. Handphone tidak boleh sama";
              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputKlinikData[i].error["nomor_telp"].error = true;
          this.tmpInputKlinikData[i].error["nomor_telp"].desc = "";
          needDbChecks.push(i);
        }
      });

      if (needDbChecks.length > 0) {
        let newNeedDbChecks = [];
        needDbChecks.forEach(item => {
          let valDb = this.tmpInputKlinikData[item].nomor_telp;
          if (this.tlpLayananExistsInDb.indexOf(valDb) > -1) {
            this.tmpInputKlinikData[item].error["nomor_telp"].error = false;
            this.tmpInputKlinikData[item].error["nomor_telp"].desc =
              "No. Handphone telah didaftarkan";
          } else newNeedDbChecks.push(item);
        });
        needDbChecks = newNeedDbChecks;

        this._timeoutKodeLayanan = setTimeout(() => {
          needDbChecks.forEach(item => {
            this.$axios
              .post(
                `klinik/pic/phone/cek`,
                {
                  klinik_id: this.getKlinikId,
                  telp: this.tmpInputKlinikData[item].nomor_telp
                }
              )
              .then(response => {
                if (response.data.status == false) {
                  this.tmpInputKlinikData[item].error[
                    "nomor_telp"
                  ].error = false;
                  this.tmpInputKlinikData[item].error["nomor_telp"].desc =
                    "No. Handphone telah didaftarkan";
                  this.tlpLayananExistsInDb.push(
                    this.tmpInputKlinikData[item].nomor_telp
                  );
                }
              })
              .catch(error => {})
              .finally(() => {
                clearTimeout(this._timeoutKodeLayanan);
              });
          });
        }, 600);
      }
    },
    onInputEmail(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      Vue.set(o, p, val);
      Vue.set(this.emailLayananContainer, index, val);

      if (val == "" || val == null) {
        this.tmpInputKlinikData[index].error["email"].error = false;
        this.tmpInputKlinikData[index].error["email"].desc =
          "Kolom Harus Diisi";
        return;
      } else if(val.match(/^([A-Za-z][A-Za-z0-9\-\.\_\+]*)\@([A-Za-z][A-Za-z0-9\-\_\+]*)(\.[A-Za-z][A-Za-z0-9\-\_\+]*)+$/) == null) {
        this.tmpInputKlinikData[index].error["email"].error = false;
        this.tmpInputKlinikData[index].error["email"].desc =
          "Format email salah";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];
      this.emailLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.emailLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item == item2 && item != "" && item2 != "") {
              this.tmpInputKlinikData[i].error["email"].error = false;
              this.tmpInputKlinikData[i].error["email"].desc =
                "Email tidak boleh sama";
              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputKlinikData[i].error["email"].error = true;
          this.tmpInputKlinikData[i].error["email"].desc = "";
          needDbChecks.push(i);
        }
      });

      if (needDbChecks.length > 0) {
        let newNeedDbChecks = [];
        needDbChecks.forEach(item => {
          let valDb = this.tmpInputKlinikData[item].email;
          if (this.emailLayananExistsInDb.indexOf(valDb) > -1) {
            this.tmpInputKlinikData[item].error["email"].error = false;
            this.tmpInputKlinikData[item].error["email"].desc =
              "Email telah ditambahkan";
          } else newNeedDbChecks.push(item);
        });
        needDbChecks = newNeedDbChecks;

        this._timeoutKodeLayanan = setTimeout(() => {
          needDbChecks.forEach(item => {
            this.$axios
              .post(
                `klinik/pic/email/cek`,
                {
                  klinik_id: this.getKlinikId,
                  email: this.tmpInputKlinikData[item].email
                }
              )
              .then(response => {
                if (response.data.status == false) {
                  this.tmpInputKlinikData[item].error[
                    "email"
                    ].error = false;
                  this.tmpInputKlinikData[item].error["email"].desc =
                    "Email telah didaftarkan";
                  this.emailLayananExistsInDb.push(
                    this.tmpInputKlinikData[item].email
                  );
                }
              })
              .catch(error => {})
              .finally(() => {
                clearTimeout(this._timeoutKodeLayanan);
              });
          });
        }, 600);
      }
    },
    addInputklinikData() {
      const { tmpInputKlinikData, validateAll, generateErrorObj } = this;
      const lastIndex = tmpInputKlinikData[tmpInputKlinikData.length - 1];
      const x = Object.keys(lastIndex);
      const tmp = x.reduce((obj, key) => {
        if (key === "error") {
          obj[key] = x
            .filter(item => item !== "error")
            .reduce((obj, keyChild) => {
              obj[keyChild] = generateErrorObj();
              return obj;
            }, {});
        } else if (key === "id") {
          obj[key] = tmpInputKlinikData.length + 1;
        } else {
          obj[key] = null;
        }
        return obj;
      }, {});
      validateAll();
      this.tmpInputKlinikData = [...tmpInputKlinikData, tmp];
    },
    removeInputklinikData(index) {
      const { tmpInputKlinikData } = this;
      if (tmpInputKlinikData.length > 1) {
        const tmp = tmpInputKlinikData
          .slice(0, index)
          .concat(
            tmpInputKlinikData.slice(index + 1, tmpInputKlinikData.length)
          );
        this.tmpInputKlinikData = tmp;
        this.emailLayananContainer = tmp.map(item => {
          return item.email
        });
        this.namaLayananContainer = tmp.map(item => {
          return item.nama
        });
        this.tlpLayananContainer = tmp.map(item => {
          return item.nomor_telp
        });
        this.klinikLayananContainer = tmp.map(item => {
          return {id: item.klinik_id, label: item.nama_klinik}
        });

        this.tmpInputKlinikData.forEach((v,i) => {
          if(v.email != null && v.email != "") this.onInputEmail(v.email, i, v, 'email')
          if(v.nomor_telp != null && v.nomor_telp != "") this.onInputNomorTelp(v.nomor_telp, i, v, 'nomor_telp')
          if(v.nama_klinik != null && v.nama_klinik != "") this.onDataKlinik({id: v.klinik_id, label: v.nama_klinik}, i, v, 'nama_klinik')
          this.validateAll()
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.invalid-feedback {
  min-height: 18px;
  display: block;
}
</style>
